// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 8161 ? "12b1eb73" : chunkId) + "." + {"390":"b69423d8d6c2958f","1600":"4232e35bd82ff426","8161":"6132e271a995a1a6","8862":"9b04c27ca6ce8578"}[chunkId] + ".js";
};